<template>
  <v-system-bar
    v-if="model"
    app
    class="hh-system-bar px-4"
    color="#06041A"
    dark
    height="44"
  >
    <v-spacer />

    <a
      class="hh-system-bar__link"
      href="https://apps.apple.com/us/app/total-chaos/id6760237060"
      rel="noopener"
      target="_blank"
    >
      <span class="hh-system-bar__dot" />
      Total Chaos is live on the App Store.
      <span class="hidden-xs-only">Free party games for iPhone.</span>
    </a>

    <v-spacer />

    <v-btn
      aria-label="Dismiss announcement"
      class="mr-n2"
      icon
      small
      @click="model = false"
    >
      <v-icon small>
        mdi-close
      </v-icon>
    </v-btn>
  </v-system-bar>
</template>

<script>
  export default {
    name: 'HomeSystemBar',

    data: () => ({
      model: true,
    }),
  }
</script>

<style lang="sass">
  .hh-system-bar
    border-bottom: 1px solid var(--hh-line)
    font-size: .9rem

    &__link
      color: var(--hh-text) !important
      text-decoration: none
      display: inline-flex
      align-items: center
      gap: 10px

      &:hover
        color: var(--hh-cyan) !important

    &__dot
      width: 8px
      height: 8px
      border-radius: 50%
      background: var(--hh-mint)
      box-shadow: 0 0 0 4px rgba(127, 245, 216, .18)
</style>
